import React, { Component } from 'react';
import Keyboard from 'simple-keyboard';
import 'simple-keyboard/build/css/index.css';

class CustomKeyboard extends Component {

	constructor(props){
		super(props);

		this.state = {
			"show": false
		}

		//

		window.ppz.customKeyboard = this;
	}

	componentDidMount() {
		const keyboard = new Keyboard({
			onChange: this.onChange,
			onKeyPress: this.onKeyPress,
			mergeDisplay: true,
			layoutName: "default",
			layout: {
				default: [
					"Q W E R T Y U I O P",
					"A S D F G H J K L",
					"Z X C V B N M {backspace}",
				],
				shift: [
					"Q W E R T Y U I O P",
					"A S D F G H J K L",
					"{shift} Z X C V B N M {backspace}",
					"{numbers} {space} {ent}"
				],
				numbers: ["1 2 3", "4 5 6", "7 8 9", "{abc} 0 {backspace}"]
			},
			display: {
				"{numbers}": "123",
				"{ent}": "return",
				"{escape}": "esc ⎋",
				"{tab}": "tab ⇥",
				"{backspace}": "⌫",
				"{capslock}": "caps lock ⇪",
				"{shift}": "⇧",
				"{controlleft}": "ctrl ⌃",
				"{controlright}": "ctrl ⌃",
				"{altleft}": "alt ⌥",
				"{altright}": "alt ⌥",
				"{metaleft}": "cmd ⌘",
				"{metaright}": "cmd ⌘",
				"{abc}": "ABC"
			}
		 });
	}

	onChange(input) {
		//console.log("Input changed", input);
	}
  
	onKeyPress(button) {
		if(button === "{backspace}"){
			const keycode = 8;
			window.ppz.crossword.handleKeyPress(8);
		}
		else {
			const letter = button.toUpperCase();
			const keycode = letter.charCodeAt(0);

			window.ppz.crossword.handleKeyPress(keycode);
		}

		console.log("Button pressed", button);
	}

	showKeyboard(){
		this.setState({
			"show": true
		});
	}

	hideKeyboard(){
		this.setState({
			"show": false
		});
	}

	render() {
		const keyboardStyles = {height:'100%', width:'100%', position:'relative', zIndex:'999999'};

		let showStyle = "";
		if(this.state.show === true){
			showStyle = "show";
		}

		return (
			<div id="customKeyboard" className={showStyle} ref="customKeyboard">
				<div style={keyboardStyles}>
					<div className="simple-keyboard"></div>
				</div>
				{/* <div className="closeBtn" onClick={() => this.hideKeyboard()}>X</div> */}
			</div>
		);
	}
}

export default CustomKeyboard;


// WEBPACK FOOTER //
// ./src/js/components/gamepage/CustomKeyboard.js